<div class="content">
  <form #exportForm="ngForm" data-qa="export-form" fxLayout="row" fxLayoutGap="2rem" fxLayoutAlign="center center">

    <mat-form-field redispatchProvideReadonly fxFlex>
      <mat-label>Netzbetreiber</mat-label>
      <input type="text"
        data-qa="netzbetreiber-input"
        required
        matInput
        [formControl]="myControl"
        [matAutocomplete]="auto">
      @if (myControl.value) {
        <button
          matSuffix
          mat-icon-button
          aria-label="Clear"
          data-qa="netzbetreiber-input-clear"
          (click)="myControl.setValue('')">
          <mat-icon svgIcon="innogy_picto_close"></mat-icon>
        </button>
      }
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn">
        @for (netzbetreiber of netzbetreiberList$ | async; track netzbetreiber.stadtwerkeId) {
          <mat-option [value]="netzbetreiber"
            data-qa="filter-netzbetreiber-option">
            {{displayFn(netzbetreiber)}}
          </mat-option>
        }
      </mat-autocomplete>
      @if (myControl.errors) {
        <mat-error>
          Bitte wählen Sie einen Netzbetreiber aus
        </mat-error>
      }
    </mat-form-field>

    <div class="buttons">
      <button matButton="filled" type="submit"
        [disabled]="loadingSingle || !myControl.valid"
        data-qa="submit-export-button"
        (click)="export()">
        @if (loadingSingle) {
          <mat-spinner [diameter]="24"></mat-spinner>
        } @else {
          <mat-icon>cloud_upload</mat-icon>
        }
        <span>Exportieren</span>
      </button>

      <button matButton="outlined" type="button"
        [disabled]="loadingAll"
        data-qa="submit-export-all-button"
        (click)="exportAll()">
        @if (loadingAll) {
          <mat-spinner [diameter]="24"></mat-spinner>
        } @else {
          <mat-icon>cloud_upload</mat-icon>
        }
        <span>Alle exportieren</span>
      </button>
    </div>

  </form>
</div>
